import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../css/trimmis.scss';

class NewsLetter extends Component {

  render() {
    return (
      <div className="trimmis-newsletter">
        <div className="col-sm-4">
          <h2>{this.props.title}</h2>
          <p>{this.props.text}</p>
        </div>
        <div className="col-sm-7 col-sm-offset-1">
          <div className="input-group">
            <input className="form-control" placeholder="E-mail" /> <span className="input-group-addon"><i className="glyphicon glyphicon-chevron-right"></i></span>
          </div>
        </div>
        <div className="clearfix"></div>
      </div>
    );
  }
}

export default NewsLetter;


// WEBPACK FOOTER //
// ../components/NewsLetter.js